import { addLocaleData } from 'react-intl';
import es from 'react-intl/locale-data/es';

import * as EnglishUS from './en-US';
import type { IMessages } from './MessageKeys';

addLocaleData(es);
const languageCode = 'es-MX';

const messages: IMessages = {
	...EnglishUS.messages,
};

export { messages, languageCode };

export default messages;
